<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/community/community' }"
            >小区管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>楼栋管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-input
              v-model="searchForm.title"
              autocomplete="off"
              maxlength="30"
              placeholder="楼栋名称"
              clearable
              size="small"
              @change="searchChange"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              size="small"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-plus"
              type="success"
              @click="handleNewAdd"
              size="small"
              >新增楼栋</el-button
            >
            <el-button
              type="info"
              icon="el-icon-upload2"
              @click="filePut"
              size="small"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!---- 分割 --->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/community/community' }"
        >小区管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>楼栋管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="queryForm" :model="searchForm" inline label-width="68px">
      <el-form-item label="楼栋名称">
        <el-input
          v-model="searchForm.title"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchChange"
          size="mini"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" @click="resets" size="mini"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      icon="el-icon-plus"
      plain
      @click="handleNewAdd"
      size="mini"
      style="margin-top: 2vh"
      >新增楼栋</el-button
    >
    <el-button
      type="info"
      icon="el-icon-plus"
      plain
      @click="filePut"
      size="mini"
      style="margin-top: 2vh"
      >导出</el-button
    > -->
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="xiaoqu_name" label="小区名称" align="center" />
      <el-table-column prop="title" label="楼栋名称" align="center" />
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="550">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="getFloor(scope.row)"
            type="success"
            size="small"
          >
            生成二维码
          </el-button>
          <el-button
            @click.native.prevent="getApps(scope.row)"
            type="info"
            size="small"
          >
            查看二维码
          </el-button>
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
          >
            修改信息
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
          >
            移除楼栋
          </el-button>
          <el-button
            @click.native.prevent="goRoom(scope.row)"
            type="warning"
            size="small"
          >
            房间管理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="楼栋名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="展示状态">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="item in regionTypes"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 小程序码弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="appOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
    >
      <el-image
        style="
          width: 100%;
          height: 50vh;
          display: flex;
          justify-content: center;
          align-items: center;
        "
        :src="appUrl"
        :preview-src-list="[appUrl]"
      >
        <div slot="error" class="image-slot">
          <div style="text-align: center; font-size: 24px">
            请生成二维码再查看！
          </div>
        </div>
      </el-image>
    </el-dialog>
  </div>
</template>
  
  <script>
import {
  getbuildList,
  addBuild,
  editBuild,
  getImg,
  deleteBuild,
} from "../../api/building";
import tableCommon from "../../../mixins/table-common";
import { getCookie } from "../../utils/util";
import axios from "axios";
export default {
  mixins: [tableCommon],
  data() {
    return {
      regionTypes: [
        {
          label: 1,
          text: "显示",
        },
        {
          label: 0,
          text: "隐藏",
        },
      ],
      api: {
        list: getbuildList,
        add: addBuild,
        edit: editBuild,
        del: deleteBuild,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {
        status: "1",
        xiaoqu_id: "",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
        xiaoqu_id: "",
      },
      // 列表数据
      tableList: [],
      // 请求id
      id: "",
      // 分页
      total: 0,
      appOpen: false,
      // 小程序码
      appUrl: "",
      // 导出地址
      exportUrl: process.env.VUE_APP_URL + "/admin/xiaoqu/roomExport",
    };
  },
  mounted() {
    this.searchForm.xiaoqu_id = this.$route.query.id;
    this.initList();
  },
  methods: {
    // 改变状态
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.actionType = "edit";
      const { xiaoqu_name, created_at, share_img, ...rest } = res;
      this.form = rest;
      editBuild(this.form).then((msg) => {
        if (msg.code !== 200) return this.$message("获取状态失败");
      });
    },
    // 导出
    filePut() {
      return axios({
        // 用axios发送get请求
        url: this.exportUrl, // 请求地址
        params: {
          xiaoqu_id: this.$route.query.id,
        }, // 参数
        method: "get",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getCookie("logintoken"),
        },
      })
        .then((res) => {
          const fileName = "小区导出文件";
          // 处理返回的文件流
          /* 兼容ie内核，360浏览器的兼容模式 */
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          /* 兼容ie内核，360浏览器的兼容模式 */
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            /* 火狐谷歌的文件下载方式 */
            let url1 = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url1;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          }
          this.$message.success("成功");
          return Promise.resolve(res.data);
        })
        .catch((err) => {
          this.$message.error("失败");
          return Promise.resolve(err);
        });
    },
    // 前往房间管理
    goRoom(res) {
      this.$router.push({
        path: "/community/room",
        query: { id: res.id, lastId: this.$route.query.id },
      });
    },
    // 打开小程序码
    getApps(res) {
      this.appOpen = true;
      this.title = "小程序码";
      this.appUrl = res.share_img;
    },
    // 生成楼栋码
    getFloor(req) {
      const appData = {
        id: req.id,
      };
      this.$confirm("确定生成小程序码？", "生成小程序码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await getImg(appData);
        if (res.code !== 200) return this.$message.error("生成失败!");
        this.$message.success("成功生成");
        this.initList();
      });
    },
    // 搜索重置
    resets() {
      this.searchForm = {
        page: 1,
        size: 10,
        title: undefined,
        xiaoqu_id: this.$route.query.id,
      };
      this.initList();
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.handleAdd();
      this.form.status = 1;
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      const { xiaoqu_name, created_at, share_img, ...rest } = row;
      this.form = rest;
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    // 提交
    submitForms() {
      this.form.xiaoqu_id = this.$route.query.id;
      this.submitForm();
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/community/building.vue